export const questions = [
  {
    title: "Какие данные у нас есть?",
    answer: `В нашем сервисе собраны данные из 10 источников:
    goszakupki.by,
    icetrade.by,
    zakupki.butb.by,
    ppt.butb.by,
    sapsrm.beloil.by,
    zakupki.minsktrans.by,
    belaruskali.by,
    bidmart.by,
    naftan.by,
    belarus-tr.gazprom.ru.`,
  },
  {
    title: "Сколько пользователей может быть на одном аккаунте?",
    answer:
      "Наш сервис многопользовательский. Все, кому вы передадите логин и пароль от своего аккаунта, смогут им пользоваться. Ограничений нет.",
  },
  {
    title: "Как часто появляются новые данные в сервисе?",
    answer:
      "Сервис обновляется каждые 5–15 минут. Около 30 000 новых лотов ежедневно появляются в сервисе.",
  },
  {
    title: "Сколько ключевых слов можно указать в поисковом фильтре?",
    answer:
      "Вы можете указать любое количество ключевых слов и других параметров для автоматического подбора своих тендеров. Ограничений нет.",
  },
  {
    title: "Можно пользоваться сервисом бесплатно?",
    answer:
      "Да. Сервисом можно пользоваться бесплатно. При отсутствии платной подписки в вашем аккаунте будет работать вкладка «Все». Вы можете искать тендеры по одному ключевому слову, а также сортировать и фильтровать тендеры в ручном режиме без автоматизации.",
  },
  {
    title: "Триал период?",
    answer:
      "Для каждого нового зарегистрированного аккаунта действует пробный период — 7 дней. За это время можно ознакомиться со всем функционалом сервиса, а наши специалисты техподдержки проведут подробную презентацию и проконсультируют по всем вопросам.",
  },
  {
    title: "Можно продлить триал?",
    answer:
      "Да. Если вы не успели ознакомиться с сервисом, вы можете персонально договориться с менеджером о продлении триала.",
  },
  {
    title: "Что по техподдержке?",
    answer:
      "За каждым пользователем закрепляется персональный менеджер и специалист техподдержки. Они на связи с 9:00 до 17:00 в рабочие дни.",
  },
];
